var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
var Checkbox = /** @class */ (function (_super) {
    __extends(Checkbox, _super);
    function Checkbox(props) {
        var _this = _super.call(this, props) || this;
        _this.onChange = function (event) {
            _this.props.handler && _this.props.handler(event);
        };
        return _this;
    }
    Checkbox.prototype.render = function () {
        return (React.createElement("span", { className: "rj-checkbox" },
            React.createElement("input", { type: "checkbox", id: this.props.id, className: "rj-checkbox__input", checked: this.props.checked, disabled: this.props.disabled, onChange: this.onChange }),
            React.createElement("label", { htmlFor: this.props.id, className: "rj-checkbox__label", "data-uat": this.props.dataUat }, this.props.children)));
    };
    return Checkbox;
}(React.Component));
export { Checkbox };
//# sourceMappingURL=Checkbox.js.map